// extracted by mini-css-extract-plugin
module.exports = {"root":"SlideOne-module--root--1-Lnq","container":"SlideOne-module--container--2fYM-"};